/**
 * Cliente HTTP del Portal de Clientes (separado del auth del despacho).
 * Token en sessionStorage; no dispara refresh de /auth del workspace.
 */
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const PORTAL_API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "mat_portal_token";

export function getPortalToken() {
  try {
    return sessionStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
}

export function setPortalToken(token) {
  try {
    if (token) sessionStorage.setItem(TOKEN_KEY, token);
    else sessionStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

export function clearPortalToken() {
  setPortalToken("");
}

const portalHttp = axios.create({
  baseURL: PORTAL_API,
  withCredentials: true,
  timeout: 120000,
});

portalHttp.interceptors.request.use((config) => {
  const t = getPortalToken();
  if (t && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export async function portalLogin(login, password) {
  const { data } = await portalHttp.post("/portal-materialidad/auth/login", { login, password });
  if (data?.access_token) setPortalToken(data.access_token);
  return data;
}

export async function portalLogout() {
  try {
    await portalHttp.post("/portal-materialidad/auth/logout");
  } catch {
    /* ignore */
  }
  clearPortalToken();
}

export async function portalMe() {
  const { data } = await portalHttp.get("/portal-materialidad/auth/me");
  return data;
}

export async function portalChangePassword(currentPassword, newPassword) {
  const { data } = await portalHttp.post("/portal-materialidad/auth/change-password", {
    current_password: currentPassword,
    new_password: newPassword,
  });
  return data;
}

export async function portalCompanies() {
  const { data } = await portalHttp.get("/portal-materialidad/companies");
  return data;
}

export async function portalCompanyRequests(clientId) {
  const { data } = await portalHttp.get(
    `/portal-materialidad/companies/${encodeURIComponent(clientId)}/requests`,
  );
  return data;
}

export async function portalRequestDetail(requestId) {
  const { data } = await portalHttp.get(
    `/portal-materialidad/requests/${encodeURIComponent(requestId)}`,
  );
  return data;
}

export async function portalUploadItem(itemId, file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await portalHttp.post(
    `/portal-materialidad/items/${encodeURIComponent(itemId)}/upload`,
    fd,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return data;
}

export async function portalSecureRequest(token) {
  const { data } = await portalHttp.get(
    `/portal-materialidad/solicitud/${encodeURIComponent(token)}`,
  );
  return data;
}

export async function portalSecureUpload(token, itemId, file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await portalHttp.post(
    `/portal-materialidad/solicitud/${encodeURIComponent(token)}/items/${encodeURIComponent(itemId)}/upload`,
    fd,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return data;
}
